class GccApiNetworkError extends Error {
  constructor() {
    super('GccApiClient: Network Error');
  }
}

export default GccApiNetworkError;
